export default __webpack_public_path__ + "static/media/kitchen5-beforeC.25a0e063.jpg";